import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { pageTitle } from "../../helper";
import Div from "../Div";
import PageHeading from "../PageHeading";
import SectionHeading from "../SectionHeading";
import Spacing from "../Spacing";
import ContactInfoWidget from "../Widget/ContactInfoWidget";
import axios from "axios"; // Import axios
import ReactDOMServer from "react-dom/server"; // Import ReactDOMServer
import EmailTemplate from "../EmailTemplate/EmailTemplate";
import { API_BASE_URL } from "../../constants";

export default function Appointment() {

  pageTitle("Appointment");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const sendMail = async (
    fullName,
    work,
    email,
    projectType,
    mobile,
    scopeOfProject
  ) => {
    try {
      const emailBody = ReactDOMServer.renderToString(
        <EmailTemplate
          fullName={fullName}
          appointment={work}
          email={email}
          projectType={projectType}
          mobile={mobile}
          scopeOfProject={scopeOfProject}
        />
      );

      await axios.post(`${API_BASE_URL}/message/create`, {
        subject: fullName,
        text: emailBody,
      });

      await axios.post(`${API_BASE_URL}/email/send/`, {
        subject: fullName,
        text: emailBody,
      });
      
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    const fullName = formData.get("fullName");
    const email = formData.get("email");
    const projectType = formData.get("projectType");
    const mobile = formData.get("mobile");
    const description = formData.get("description");

    // Client-side validation
    if (!fullName || !email || !projectType || !mobile || !description) {
      setError("All fields are required.");
      return;
    }

    setError(null); // Clear any previous error messages

    try {
      // Call sendMail function with extracted form data
      await sendMail(fullName, "Appointment", email, projectType, mobile, description);
      navigate("/success", { state: { fromContactOrServiceForm: true } });

      // Handle success response from the backend
      console.log("Message sent successfully");
      event.target.reset(); // Reset the form fields
    } catch (error) {
      // Handle error
      console.error("Error:", error);
    }
  };

  return (
    <>
      <PageHeading
        title="Appointment Form"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="appointment"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading
              title="You are just <br/>One Step Away"
              subtitle="Fill in your details"
            />
            <Spacing lg="55" md="30" />
            <ContactInfoWidget withIcon />
            <Spacing lg="0" md="50" />
          </Div>
          <Div className="col-lg-6">
            <form onSubmit={handleSubmit} className="row">
              <Div className="col-sm-6">
                <label className="cs-primary_color">Full Name*</label>
                <input
                  type="text"
                  name="fullName"
                  className="cs-form_field"
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Email*</label>
                <input
                  type="email"
                  name="email"
                  className="cs-form_field"
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Project Type*</label>
                <input
                  type="text"
                  name="projectType"
                  className="cs-form_field"
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Phone Number*</label>
                <input
                  type="text"
                  name="mobile"
                  className="cs-form_field"
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-12">
                <label className="cs-primary_color">
                  Short Description of the Project*
                </label>
                <textarea
                  name="description"
                  cols="30"
                  rows="7"
                  className="cs-form_field"
                  required
                ></textarea>
                <Spacing lg="25" md="25" />
              </Div>
              <Div className="col-sm-12">
                <button type="submit" className="cs-btn cs-style1">
                  <span>Send Message</span>
                  <Icon icon="bi:arrow-right" />
                </button>
              </Div>
            </form>
            {error && <p className="error">{error}</p>}
          </Div>
        </Div>
      </Div>
    </>
  );
}
